import { TwinDictionary } from '../globals/dictionary'
import useTwinTranslation from './useTwinTranslation'

const useModulesTranslations = () => {
    const { t } = useTwinTranslation()

    const defaultOrderTypesDict: TwinDictionary = {
        'companyName': t('companyName', 'Nombre de la empresa'),
        'company_phone': t('companyPhone', 'Teléfono de la empresa'),
        'company_mobile': t('companyMobile', 'Móvil de la empresa'),
        'company_IdNumber': t('companyIdNumber', 'ID de la empresa'),
        'companyAddress': t('companyAddress', 'Dirección de la empresa'),
        'companyAddress_additional': t('companyAddress_additional', 'Dirección adicional de la empresa'),
        'companyAddress_postalCode': t('companyAddress_postalCode', 'Código postal de la empresa'),
        'companyAddress_city': t('companyAddress_city', 'Ciudad de la empresa'),
        'companyAddress_country': t('companyAddress_country', 'País de la empresa'),
        'assigned_number': t('assigned_number', 'Número asignado'),
        'finished_date': t('finished_date', 'Fecha de vencimiento'),
        'processed_date': t('processed_date', 'Fecha de envío'),
        'finished_date_complete': t('finished_date_complete', 'Fecha de vencimiento completa'),
        'processed_date_complete': t('processed_date_complete', 'Fecha de envío completa'),
        'version': t('version', 'Versión'),
        'shipment_method': t('shipment_method', 'Método de envío'),
        'is_last': t('is_last', 'Último'),
        'status': t('status', 'Estado'),
        'typeShipping': t('typeShipping', 'Tipo de envío'),
        'notes': t('notes', 'Notas'),
        'total_subtotalCosts': t('total_subtotalCosts', 'Subtotal de costes'),
        'total_subtotalProducts': t('total_subtotalProducts', 'Subtotal de productos'),
        'total_subtotal': t('total_subtotal', 'Subtotal'),
        'total_subtotal_simple': t('total_subtotal_simple', 'Subtotal simple'),
        'total_discounts_before': t('total_discounts_before', 'Descuentos antes de impuestos'),
        'total_discounts_before_simple': t('total_discounts_before_simple', 'Descuentos antes de impuestos simple'),
        'total_discounts_before_per_row': t('total_discounts_before_per_row', 'Descuentos por línea antes de impuestos'),
        'total_discounts_after': t('total_discounts_after', 'Descuentos después de impuestos'),
        'total_without_vat': t('total_without_vat', 'Total sin impuestos'),
        'total_vat': t('total_vat', 'Total de impuestos'),
        'total_vat_simple': t('total_vat_simple', 'Total de impuestos simple'),
        'total_vat2': t('total_vat2', 'Total recargo equivalencia'),
        'total_vat2_simple': t('total_vat2', 'Total recargo equivalencia simple'),
        'total_total': t('total_total', 'Total'),
        'total_total_simple': t('total_total_simple', 'Total simple'),
        'total_to_pay': t('total_to_pay', 'Total a pagar'),
        'total_to_pay_simple': t('total_to_pay_simple', 'Total a pagar simple'),
        'total_subtotal_after': t('total_subtotal_after', 'Subtotal despues de imp.'),
        'total_subtotal_after_simple': t('total_subtotal_after_simple', 'Subtotal despues de imp. simple'),
        'total_payed': t('total_payed', 'Total pagado'),
        'total_payed_simple': t('total_payed_simple', 'Total pagado simple'),
        'SpecificPriceRuleIds': t('specificPriceRuleIds', 'Regla de precio específico (ID)'),
        'CreateEmployeeId': t('createEmployeeId', 'ID Empleado creado'),
        'ProcessEmployeeId': t('processEmployeeId', 'ID Empleado procesado'),
        'CurrencyId': t('currency', 'Moneda'),
        'CustomerId': t('customerId', 'ID Cliente'),
        'Customer_Code': t('customerCode', 'Código del cliente'),
        'Customer_Name': t('customer_Name', 'Nombre del cliente'),
        'Customer_FullName': t('customer_FullName', 'Nombre completo del cliente'),
        'Customer_Fiscal_Name': t('customerFiscalName', 'Nombre fiscal del cliente'),
        'Customer_IdNumber': t('customerIdNumber', 'Número Identidad del cliente'),
        'WorkingCenterId': t('workingCenterId', 'ID Centro de trabajo'),
        'WorkingCenter_idNumber': t('WorkingCenterIdNumber', 'Número de identidad del Centro de trabajo'),
        'WorkingCenter_phone': t('WorkingCenterPhone', 'Teléfono del Centro de trabajo'),
        'WorkingCenter_mobile': t('WorkingCenterIdPhone', 'Móvil del Centro de trabajo'),
        'WorkingCenterAddress': t('workingCenterAddress', 'Dirección del centro de trabajo'),
        'WorkingCenterAddress_additional': t('workingCenterAddress_additional', 'Dirección adicional del centro de trabajo'),
        'WorkingCenterAddress_postalCode': t('workingCenterAddress_postalCode', 'Código postal del centro de trabajo'),
        'WorkingCenterAddress_city': t('workingCenterAddress_city', 'Ciudad del centro de trabajo'),
        'WorkingCenterAddress_country': t('workingCenterAddress_country', 'País del centro de trabajo'),
        'CustomerAddress': t('customerAddress', 'Dirección del cliente'),
        'CustomerAddress_additional': t('customerAddress_additional', 'Dirección adicional del cliente'),
        'CustomerAddress_postalCode': t('customerAddress_postalCode', 'Código postal del cliente'),
        'CustomerAddress_city': t('customerAddress_city', 'Ciudad del cliente'),
        'CustomerAddress_country': t('customerAddress_country', 'País del cliente'),
        'OrderShippingId': t('orderShippingId', 'ID Método de envío'),
        'OrderId': t('quoteOrderId', 'ID del presupuesto'),
        'orderDate': t('orderDate', 'Fecha del presupuesto'),
        'ShippingAddress': t('shippingAddress', 'Dirección de envío'),
        'ShippingAddress_additional': t('shippingAddress_additional', 'Dirección de envío adicional'),
        'ShippingAddress_postalCode': t('shippingAddress_postalCode', 'Código postal de envío'),
        'ShippingAddress_city': t('shippingAddress_city', 'Ciudad de envío'),
        'ShippingAddress_country': t('shippingAddress_country', 'País de envío'),
        'OrderShipping_finalPriceWithTax': t('orderShipping_finalPriceWithTax', 'Gastos de envío con impuestos'),
        'OrderShipping_finalPriceWithoutTax': t('orderShipping_finalPriceWithoutTax', 'Gastos de envío sin impuestos'),
        'ProductId': t('ProductId', 'ID del producto'),
        'OrderAddonGroupId': t('OrderAddonGroupId', 'ID del grupo de comp.'),
        'product_notes': t('product_notes', 'Notas del producto'),
        'delivery_date': t('delivery_date', 'Fecha de entrega'),
        'quantity': t('quantity', 'Cantidad'),
        'quantity_simple': t('quantitySimple', 'Cantidad simple'),
        'minQuantity': t('minQuantity', 'Cantidad mínima'),
        'nLine': t('line', 'Línea'),
        'isPack': t('isPack', 'Pack'),
        'packQuantities': t('packQuantities', 'Cantidad del pack'),
        'typeQuantity': t('typeQuantity', 'Tipo de cantidad'),
        'label': t('label', 'Etiqueta'),
        'discount': t('discount', 'Descuento'),
        'taxUsed': t('taxUsed', 'Impuesto usado'),
        'taxUsed2': t('secondTaxUsed', 'Segundo Impuesto usado'),
        'unique_number': t('unique_number', 'Número único'),
        'initialUnitPriceWithoutTax': t('initialUnitPriceWithoutTax', 'Precio unitario inicial sin impuestos'),
        'initialUnitPriceWithTax': t('initialUnitPriceWithTax', 'Precio unitario inicial con impuestos'),
        'initialUnitPriceWithTax_simple': t('initialUnitPriceWithTaxSimple', 'Precio unitario inicial con impuestos simple'),
        'finalUnitPriceWithoutTax': t('finalUnitPriceWithoutTax', 'Precio unitario final sin impuestos'),
        'rowPriceWithoutTaxPrev': t('rowPriceWithoutTaxPrev', 'Precio fila sin impuestos ni descuentos'),
        'rowPriceWithoutTaxAndTotalDiscount': t('rowPriceWithoutTax', 'Precio de fila sin impuestos'),
        'rowPriceWithoutTax': t('rowPriceWithoutTaxWithFinalDisc', 'Precio de fila sin impuestos y con descuentos totales'),
        'finalUnitPriceWithTax': t('finalUnitPriceWithTaxs', 'Precio unitario final con impuestos'),
        'finalUnitPriceWithTax_simple': t('finalUnitPriceWithTaxsSimple', 'Precio unitario final con impuestos simple'),
        'rowPriceWithTax': t('rowPriceWithTax', 'Precio de fila con impuestos'),
        'rowPriceWithTax_simple': t('rowPriceWithTaxSimple', 'Precio de fila con impuestos simple'),
        'totalWithoutTaxWithComplements': t('totalWithoutTaxWithComplements', 'Precio total con complementos'),
        'totalWithoutTaxWithComplementsPrev': t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de desc.'),
        'totalWithTaxWithComplements': t('totalWithTaxWithComplements', 'Precio total con complementos e impuestos'),
        'totalWithTaxWithComplements_simple': t('totalWithTaxWithComplementsSimple', 'Precio total con complementos e impuestos simple'),
        'totalWithoutTaxWithComplementsCompensed': t('totalWithoutTaxWithComplementsCompensed', 'Precio total compensado con complementos'),
        'rowPriceWithoutTaxAndCompensatoryValue': t('rowPriceWithoutTaxAndCompensatory', 'Precio de fila sin impuestos con compensación'),
        'rowPriceWithoutTaxPrevAndCompensatoryValue': t('rowPriceWithoutTaxPrevAndCompensatory', 'Precio de fila sin impuestos antes de desc. con compensación'),
        'compensatoryValuePrev': t('compensatory', 'Compensación'),
        'unitPriceWithComplements': t('unitPriceWithComplements', 'Precio unitario con complementos'),
        'extraLineDiscountRow': t('lineDiscount', 'Descuentos de la fila'),
        'extraLineDiscount': t('extraLineDiscountWithTotals', 'Descuentos extra con descuentos totales'),
        'extraLineRecharge': t('extraLineRecharge', 'Línea de recargo extra'),
        'Product_Reference': t('product_Reference', 'Referencia de producto'),
        'Product_Secondary_Reference': t('productSecondaryReference', 'Referencia secundaria de producto'),
        'Product_Name': t('product_Name', 'Nombre de producto'),
        'Product_Description': t('product_Description', 'Descripción del producto'),
        'Product_Short_Description': t('productShortDescription', 'Descripción corta del producto'),
        'Product_CodeBar': t('product_CodeBar', 'Código de barras de producto'),
        'Product_Weight': t('product_weight', 'Peso del producto'),
        'Product_Price': t('product_price', 'Precio del producto'),
        'Product_Image': t('product_Image', 'Imagen de producto'),
        'Cost_Name': t('costName', 'Nombre del gasto'),
        'costPriceWithoutTax': t('costPriceWithoutTax', 'Gasto sin impuestos'),
        'costPriceWithTax': t('costPriceWithTax', 'Gasto con impuestos'),
        'costTaxUsed': t('costTaxUsed', 'Impuesto'),
        'costTotalTax': t('costTotalTax', 'Total impuestos'),
        'date': t('date', 'Fecha'),
        'Chapter_Name': t('chapterName', 'Nombre del capítulo'),
        'Chapter_Description': t('chapterDescription', 'Descripción del capítulo'),
        'total_recharge_before': t('total_recharge_before', 'Recargos antes de impuestos'),
        'total_recharge_after': t('total_recharge_after', 'Recargos después de impuestos'),
        'ChapterId': t('chapterId', 'Id del capítulo'),
        'documentType': t('documentType', 'Tipo de documento'),
        'Warehouse_Name': t('warehouse', 'Almacén'),
        'RepresentativeEmployee_name': t('representativeEmployeeName', 'Nombre del representante'),
        'RepresentativeEmployee_fullNameShort': t('representativeEmployeeFullNameShort', 'Nombre y ap. del representante'),
        'RepresentativeEmployee_fullNameLong': t('representativeEmployeeFullNameLong', 'Nombre completo del representante'),
        'RepresentativeEmployee_email': t('representativeEmployeeEmail', 'Email del representante'),
        'RepresentativeEmployee_phone': t('representativeEmployeePhone', 'Teléfono del representante'),
        'FirstFinancialRowQuantity': t('firstFinancialRow', 'Primer descuento o recargo de pie'),
        'FirstFinancialRowType': t('firstFinancialRowType', 'Tipo del primer Primer descuento o recargo de pie'),
        'RepresentativeEmployee_mobile': t('representativeEmployeeMobile', 'Móvil del representante'),
        'FinancialRow_id': t('id', 'ID'),
        'position': t('orderPos', 'Posición'),
        'quantityFinancialRow': t('quantity', 'Cantidad'),
        'financialRowType': t('discountOrRecharge', 'Descuento o recargo'),
        'signature': t('signature', 'Firma'),
        'PaymentMethod_name': t('paymentMethod', 'Método de pago'),
        'PayMCopyDate_date': t('datePayment', 'Fecha pago'),
        'PayMCopyDate_quantity': t('quantityPayment', 'Cantidad pago'),
        'PayMCopyDate_quantity_simple': t('quantityPaymentSimple', 'Cantidad pago simple'),
        'PaymentType_name': t('paymentType', 'Tipo de pago'),
        'PayMCopyDate_change': t('changeMoney', 'Cambio'),
        'PayMCopyDate_change_simple': t('changeMoney', 'Cambio'),
        'PayMCopyDate_customerMoney': t('customerMoneyTotalSimple', 'Total entregado simple'),
        'PayMCopyDate_customerMoney_simple': t('customerMoneyTotalSimple', 'Total entregado simple'),
        'subTotalAfter': t('totalWithoutVat', 'Base imponible'),
        'subTotalAfter_simple': t('totalWithoutVatSimple', 'Base imponible simple'),
        'vatMoney': t('totalVat', 'Total Impuestos'),
        'vatMoney_simple': t('totalVatSimple', 'Total Impuestos simple'),
        'vatMoney2': t('totalVat2', 'Total Impuestos 2'),
        'vatMoney2_simple': t('totalVat2Simple', 'Total Impuestos 2 simple'),
        'total': t('total', 'Total'),
        'total_simple': t('totalSimple', 'Total simple'),
        'retentionMoney': t('retentionMoney', 'Retención a pagar'),
        'taxUsed_simple': t('taxSimple', 'Impuesto simple'),
        'taxUsed2_simple': t('secondTaxSimple', 'Segundo Impuesto simple'),
        'voucher_n': t('voucherN', 'Número de vale'),
        'amount': t('amount', 'Importe'),
        'amount_simple': t('amountSimple', 'Importe simple'),
        'reuses': t('uses', 'Usos'),
        'usedAmount': t('usedAmount', 'Importe usado'),
        'usedAmount_simple': t('usedAmountSimple', 'Importe usado simple'),
        'VoucherId': t('relatedVoucherId', 'Vale relacionado ID'),
        'createdAt': t('createdAt', 'Fecha de creación'),
        'createdAt_complete': t('createdAtComplete', 'Fecha de creación completa'),
        'endDate': t('closeDate', 'Fecha de cierre'),
        'OpenEmployee_name': t('OpenEmployee_name', 'Nombre del que abre'),
        'OpenEmployee_fullNameShort': t('OpenEmployee_fullNameShort', 'Nombre y ap. del que abre'),
        'CloseEmployee_fullNameShort': t('CloseEmployee_fullNameShort', 'Nombre del que cierra'),
        'CloseEmployee_name': t('CloseEmployee_name', 'Nombre y ap. del que cierra'),
        'totalPayment': t('total', 'Total'),
        'totalQuantity': t('totalQuantity', 'Cantidad total'),
        'totalPaymentSells': t('totalPaymentSells', 'Ventas totales'),
        'totalPaymentRefund': t('totalPaymentRefund', 'Devoluciones totales'),
        'totalQuantityRefund': t('totalQuantityRefund', 'Cantidad de devoluciones'),
        'totalVat': t('totalVat', 'Total Impuestos'),
        'totalVat2': t('totalVat2', 'Total Impuestos 2'),
        'totalWithoutVat': t('totalWithoutVat', 'Base imponible'),
        'totalVatSells': t('totalVatSells', 'Total Impuestos ventas'),
        'totalVat2Sells': t('totalVat2Sells', 'Total imp. 2 ventas'),
        'totalWithoutVatSells': t('totalWithoutVatSells', 'Base imponible ventas'),
        'totalVatRefund': t('totalVatRefund', 'Total impuestos devoluciones'),
        'totalVat2Refund': t('totalVat2Refund', 'Total imp. 2 devoluciones'),
        'totalWithoutVatRefund': t('totalWithoutVatRefund', 'Base imponible devoluciones'),
    }

    return { defaultOrderTypesDict }
}

export default useModulesTranslations

